export const auth = {
    authModalTitle: '需要授权',
    authModalDescription:
        '继续操作需要授权，请选择以下操作：',
    loginHeading: '登录',
    createAccount: '创建新账户',
    registrationHeading: '注册',
    pleaseFillAll: '或请将各域信息填全',
    inputWithNameIsRequired: ['域', '需要!'],
    orUse: '或使用',
    register: '注册',
    login: '登录',
    nameLabel: '用户名',
    emailLabel: '邮箱',
    passwordLabel: '密码',
    newPasswordLabel: '新密码',
    confirmPasswordLabel: '确认密码',
    firstName: '名',
    lastName: '名称',
    editProfile: '编辑配置文件',
    changePassword: '修改密码',
    iHaveRead: [
        '我已经阅读和同意',
        '条款',
        '和条件',
        '并以匿名形式',
        '完成',
        '过程。详情可咨询泛在能控客服。'
    ],

    passPolicyLength: '无效密码:最少长度为8个字符',
    passPolicyUpperCase: '无效密码:必须至少包含一个大写字母',
    passPolicyNumber: '无效密码:必须至少包含一个数字',
    passPolicyLowerCase: '无效密码:必须至少包含一个小写字母',
    passAndConfirmDontMatch: '两次输入密码不一致',

    dontHaveAnAccount: "没有账户?",
    alreadyHaveAnAccount: '已有账户?'
};
